import { SVGProps } from "react";

export const FamilyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.0001 17.3569V20.0415M12.6958 20.0415H15.3044M13.7788 16.6423C13.188 17.0908 12.4513 17.3569 11.6524 17.3569C9.70752 17.3569 8.13086 15.7794 8.13086 13.8334C8.13086 12.4915 8.88067 11.3247 9.98398 10.7297C10.3699 10.5216 10.6919 10.1941 10.9047 9.80283C11.5014 8.70561 12.6639 7.96094 14.0001 7.96094C15.3364 7.96094 16.4988 8.70561 17.0955 9.80283C17.3083 10.1941 17.6303 10.5216 18.0163 10.7297C19.1196 11.3247 19.8694 12.4915 19.8694 13.8334C19.8694 15.7794 18.2927 17.3569 16.3478 17.3569C15.549 17.3569 14.8123 17.0908 14.2214 16.6423C14.0905 16.543 13.9097 16.543 13.7788 16.6423Z"
      fill="none"
      strokeWidth="1.77073"
      strokeLinecap="round"
    />
  </svg>
);
